import React, { useState, Fragment } from 'react'

import PropTypes from 'prop-types'

import './contact-form.css'

const ContactForm = (props) => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false)
  const [showFailedMsg, setShowFailedMsg] = useState(false)
  const [showForm, setShowForm] = useState(true)
  const sendInquiry = async (event) => {
    event.preventDefault()
    const apiUrl = 'https://api.raceconsulting24.com/Prod/sendInquiry'
    const name = document.getElementById('contact-form-2-name').value
    const email = document.getElementById('contact-form-2-email').value
    const message = document.getElementById('contact-form-2-message').value
    const friendRef = document.getElementById('contact-form-ref-friend')
    const socialMediaRef = document.getElementById(
      'contact-form-ref-socialMedia'
    )
    const internetRef = document.getElementById('contact-form-ref-internet')
    var referredFrom = ''
    if (friendRef.checked) {
      referredFrom = 'Friend'
    } else if (socialMediaRef.checked) {
      referredFrom = 'Social Media'
    } else if (internetRef.checked) {
      referredFrom = 'Internet'
    } else {
      referredFrom = ''
    }
    const postData = {
      name: name,
      email: email,
      referredFrom: referredFrom,
      message: message,
    }
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        // Specify the HTTP method as POST
        headers: {
          'Content-Type': 'application/json', // Indicate that you're sending JSON data
          // Add any other necessary headers, like Authorization tokens
        },
        body: JSON.stringify(postData), // Convert your data to a JSON string
      })
      if (response.ok) {
        const responseData = await response.json() // Parse the JSON response
        console.log('API Response:', responseData)
        // You can now work with the 'responseData'
        setShowForm(false)
        setShowSuccessMsg(true)
        setShowFailedMsg(false)
      } else {
        // Handle non-successful responses (e.g., 404, 500)
        throw new Error(`HTTP error! status: ${response.status}`)
      }
    } catch (error) {
      setShowForm(false)
      setShowFailedMsg(true)
      setShowSuccessMsg(false)
      console.error('Error calling the API:', error)
    }
  }
  return (
    <div className="contact-form-container1">
      {showForm === true && (
        <form
          id="contact-form"
          encType="multipart/form-data"
          onSubmit={sendInquiry}
          className="contact-form-form"
        >
          <h1 className="contact-form-text10">
            {props.heading ?? (
              <Fragment>
                <span className="contact-form-text29">
                  Want to work with us?
                </span>
              </Fragment>
            )}
          </h1>
          <span className="contact-form-text11 TextXL">
            {props.text ?? (
              <Fragment>
                <span className="contact-form-text24">
                  Complete this form and we will get back to you in 24 hours.
                </span>
              </Fragment>
            )}
          </span>
          <span className="contact-form-text12 TextXS">
            {props.text1 ?? (
              <Fragment>
                <span className="contact-form-text28">FULL NAME *</span>
              </Fragment>
            )}
          </span>
          <input
            type="text"
            id="contact-form-2-name"
            name="name"
            required
            placeholder={props.textinputPlaceholder}
            className="contact-form-textinput1 TextSM input"
          />
          <span className="contact-form-text13 TextXS">
            {props.text2 ?? (
              <Fragment>
                <span className="contact-form-text31">EMAIL *</span>
              </Fragment>
            )}
          </span>
          <input
            type="email"
            id="contact-form-2-email"
            name="email"
            required
            placeholder={props.textinputPlaceholder1}
            className="contact-form-textinput2 TextSM input"
          />
          <span className="contact-form-text14 TextXS">
            {props.text31 ?? (
              <Fragment>
                <span className="contact-form-text27">
                  HOW DID YOU HEAR ABOUT US?
                </span>
              </Fragment>
            )}
          </span>
          <div className="contact-form-container2">
            <input
              type="radio"
              id="contact-form-ref-friend"
              name="radio"
              className="contact-form-radiobutton1"
            />
            <span className="contact-form-text15 TextXS">
              {props.text21 ?? (
                <Fragment>
                  <span className="contact-form-text25">Friend</span>
                </Fragment>
              )}
            </span>
          </div>
          <div className="contact-form-container3">
            <input
              type="radio"
              id="contact-form-ref-socialMedia"
              name="radio"
              className="contact-form-radiobutton2"
            />
            <span className="contact-form-text16 TextXS">
              {props.text211 ?? (
                <Fragment>
                  <span className="contact-form-text30">Social Media</span>
                </Fragment>
              )}
            </span>
          </div>
          <div className="contact-form-container4">
            <input
              type="radio"
              id="contact-form-ref-internet"
              name="radio"
              className="contact-form-radiobutton3"
            />
            <span className="contact-form-text17 TextXS">
              {props.text212 ?? (
                <Fragment>
                  <span className="contact-form-text23">Internet</span>
                </Fragment>
              )}
            </span>
          </div>
          <span className="contact-form-text18 TextXS">
            {props.text3 ?? (
              <Fragment>
                <span className="contact-form-text32">MESSAGE</span>
              </Fragment>
            )}
          </span>
          <textarea
            id="contact-form-2-message"
            cols="80"
            name="message"
            rows="4"
            placeholder={props.textareaPlaceholder}
            className="contact-form-textarea TextSM textarea"
          ></textarea>
          <div className="contact-form-container5">
            <button type="submit" className="contact-form-button TextXS button">
              <span>
                {props.button ?? (
                  <Fragment>
                    <span className="contact-form-text33">SEND MESSAGE</span>
                  </Fragment>
                )}
              </span>
            </button>
          </div>
        </form>
      )}
      {showSuccessMsg === true && (
        <span id="contact-form-success-msg" className="contact-form-text20">
          {props.text5 ?? (
            <Fragment>
              <span className="contact-form-text22">
                Your message has been sent!
              </span>
            </Fragment>
          )}
        </span>
      )}
      {showFailedMsg === true && (
        <span id="contact-form-failed-msg" className="contact-form-text21">
          {props.text51 ?? (
            <Fragment>
              <span className="contact-form-text26">
                There was an issue sending your inquiry.  Please try again
                later.
              </span>
            </Fragment>
          )}
        </span>
      )}
    </div>
  )
}

ContactForm.defaultProps = {
  text5: undefined,
  text212: undefined,
  text: undefined,
  textinputPlaceholder: 'Full Name',
  text21: undefined,
  text51: undefined,
  text31: undefined,
  text1: undefined,
  heading: undefined,
  textareaPlaceholder: 'Type a message',
  textinputPlaceholder1: 'Email',
  text211: undefined,
  text2: undefined,
  text3: undefined,
  button: undefined,
}

ContactForm.propTypes = {
  text5: PropTypes.element,
  text212: PropTypes.element,
  text: PropTypes.element,
  textinputPlaceholder: PropTypes.string,
  text21: PropTypes.element,
  text51: PropTypes.element,
  text31: PropTypes.element,
  text1: PropTypes.element,
  heading: PropTypes.element,
  textareaPlaceholder: PropTypes.string,
  textinputPlaceholder1: PropTypes.string,
  text211: PropTypes.element,
  text2: PropTypes.element,
  text3: PropTypes.element,
  button: PropTypes.element,
}

export default ContactForm
